<template>
  <div>
    <div class="intros">
      <div class="showinfor">
        <span>{{pagerParam.total}}{{$t('global.个频道')}}</span>
        <div class="rightside">
          <div class="defaultstate" v-show="!isEdit">
            <a @click="showAdd">{{$t('global.新增')}}</a>
            <a @click="editBtn">{{$t('global.编辑')}}</a>
          </div>
          <div class="editstate" v-if="isEdit">
            <el-checkbox v-model="checked" @change="checkAll">{{$t('global.全选')}}</el-checkbox>
            <a @click="rankPost">{{$t('global.按序号排序')}}</a>
            <a @click="deleteRelevantTopic()">{{$t('global.删除')}}</a>
            <a @click="backBtn">{{$t('global.返回')}}</a>
          </div>
        </div>
      </div>

      <div class="memberinfor">
        <ul>
          <li class="userinforbox" v-for="(page , index) of pages" :key="index">
            <div class="leftbar" v-for="item of page" :key="item.id">
              <img
                class="avatar"
                @click="selectItem(item.id)"
                :src="item.relevantTopicThumb | imageUrl('',132,132)"
              />
              <div class="usercontent">
                <p
                  class="name"
                  style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                >{{item.relevantTopicTitle}}</p>

                <p class="mavideo">
                  <span>{{$t('global.成员')}}</span>
                  <b>{{item.memberCount}}</b>
                  <span>{{$t('global.视频')}}</span>
                  <b>{{item.videoCount}}</b>

                  <span
                    class="checkedbox"
                    @click="editSelect(selectRelevantTopic,item.id)"
                    :class="{showbox:getSelect(selectRelevantTopic,item.id),show:isShow}"
                  ></span>
                  <input :class="{show:isShow}" type="text" value />
                </p>
              </div>
              <div class="clearfix"></div>
            </div>
          </li>
        </ul>
      </div>

      <template v-if="isShowAdd">
        <div>
          <div class="addfixwindow"></div>
          <div class="fixconent">
            <div class="fixconent">
              <p>{{$t('global.选择频道')}}</p>
              <div class="headsearch">
                <input
                  type="text"
                  :placeholder="$t('global.搜索频道')"
                  v-model="keyword"
                  @keyup.enter="getAllList"
                />
                <img src="/static/home/images/search.png" @click="getAllList" />
              </div>

              <div class="hostactivity">
                <ul>
                  <li v-for="item in allList" :key="item.id">
                    <div class="leftbar">
                      <img class="avatar" :src="item.thumb | imageUrl('/static/profile_img_default.png',66,66)" />
                      <div class="usercontent">
                        <p
                          class="name"
                          style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;line-clamp: 2;"
                        >{{item.title}}</p>
                        <p class="mavideo">
                          <span>{{$t('global.成员')}}</span>
                          <b>{{item.memberCount}}</b>
                          <span>{{$t('global.视频')}}</span>
                          <b>{{item.videoCount}}</b>
                          <span
                            class="checkedbox"
                            :class="{showbox:getSelect(selectList,item.id)}"
                            v-if="!getSelect(exitsList,item.id)"
                            @click="editSelect(selectList,item.id)"
                          ></span>
                          <a class="addsed" v-else>{{$t('global.已添加')}}</a>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>

                <pages
                  :page-size="wpagerParam.pageSize"
                  :page-count="wpagerParam.pageCount"
                  :current-page="wpagerParam.currentPage"
                  :total="wpagerParam.total"
                  @current-page-changed="OnwCurrentPageChanged"
                ></pages>
              </div>
              <img @click="hiddenAdd" src="/static/uploadvideo/closepopus.png" class="closepopus" />
              <div class="underbutton">
                <span>
                  {{$t('global.已选择')}}
                  <em>{{selectList.length}}</em>
                  {{$t('global.个频道')}}
                </span>
                <a @click="sureAdd" class="sure">{{$t('global.确定')}}</a>
                <a @click="hiddenAdd" class="cancel">{{$t('global.取消')}}</a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <pages
      :page-size="pagerParam.pageSize"
      :page-count="pagerParam.pageCount"
      :current-page="pagerParam.currentPage"
      :total="pagerParam.total"
      @current-page-changed="OnCurrentPageChanged"
    ></pages>
  </div>
</template>

<script>
import pages from "@/components/pages.vue";

export default {
  name: "itemStep5",
  components: {
    pages
  },
  data() {
    return {
      //列表集合，选中集合
      currentRelevantTopic: [],
      selectRelevantTopic: [],
      //新增集合，选中集合
      allList: [],
      selectList: [],
      exitsList: [],
      isShowAdd: false,
      isShowLi: true,

      isNone: false,
      checkState: true,
      num: 0,
      isShowBox: false,
      pagerParam: {
        pageSize: 10,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      wpagerParam: {
        pageSize: 6,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      isEdit: false,
      isShow: true,
      keyword: "",
      checked: false,
      rankList: []
    };
  },
  computed: {
    pages() {
      const pages = [];
      this.currentRelevantTopic.forEach((item, index) => {
        const page = Math.floor(index / 2);
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(item);
      });
      return pages;
    }
  },
  created() {
    this.topicId = this.$route.params.id;
    this.getRelevantTopicList();
  },

  methods: {
    getRelevantTopicList() {
      let $this = this;
      this.$http
        .get(
          "/api/topic/relevant/pageList?topicId=" +
            $this.topicId +
            "&orderBy=0&pageIndex=" +
            this.pagerParam.currentPage +
            "&pageSize=" +
            this.pagerParam.pageSize
        )
        .then(function(response) {
          let pagelist = response.data.pageList;
          $this.currentRelevantTopic = pagelist.list;
          //更新是否已添加状态
          $this.exitsList = response.data.ids;
          $this.pagerParam = {
            pageSize: pagelist.pageSize,
            pageCount: pagelist.totalPage,
            currentPage: pagelist.pageIndex,
            total: pagelist.totalRecord
          };
        });
    },
    getAllList() {
      let $this = this;
      this.$http
        .get("/api/topic/findList", {
          params: {
            keyword: this.keyword,
            orderBy: 0,
            pageIndex: this.wpagerParam.currentPage,
            pageSize: this.wpagerParam.pageSize
          }
        })
        .then(function(response) {
          $this.allList = response.data.list;
          $this.wpagerParam = {
            pageSize: response.data.pageSize,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.getRelevantTopicList();
    },

    OnwCurrentPageChanged(val) {
      this.wpagerParam.currentPage = val;
      this.getAllList();
    },
    editBtn() {
      this.isEdit = true;
      this.isShow = false;
    },
    backBtn() {
      this.isEdit = false;
      this.isShow = true;
      this.selectRelevantTopic = [];
    },
    editSelect(list, id) {
      let index = list.indexOf(id);
      if (index != -1) {
        list.splice(index, 1);
      } else {
        list.push(id);
      }
    },
    getSelect(list, id) {
      if (list.indexOf(id) != -1) {
        return true;
      } else {
        return false;
      }
    },
    deleteRelevantTopic() {
      if (this.selectRelevantTopic.length == 0) {
        this.$message({
          message: this.$t("global.请选择要删除的频道"),
          type: "error",
          duration: 1000
        });
        return;
      }
      let $this = this;
      this.$http
        .post("/api/topic/relevant/deleteBatch", {
          ids: this.selectRelevantTopic.join()
        })
        .then(response => {
          if (response.code == "OK") {
            $this.$message({
              message: this.$t("global.删除成功"),
              type: "success",
              duration: 1000
            });
            $this.getRelevantTopicList();
          } else {
            $this.$message({
              message: this.$t("global.删除失败"),
              type: "error",
              duration: 1000
            });
          }
        });
    },
    hiddenAdd() {
      this.isShowAdd = false;
      document.documentElement.style.overflowY = "scroll";
      //清空选择的
      this.selectList = [];
      this.keyworld = "";
    },

    showAdd() {
      this.isShowAdd = true;
      document.documentElement.style.overflowY = "hidden";
      this.getAllList();
    },

    sureAdd() {
      //$t('global.确定添加')
      if (this.selectList.length == 0) {
        this.$message({
          message: this.$t("global.请选择要添加的频道"),
          type: "error",
          duration: 1000
        });
        return;
      }
      this.isShowAdd = false;
      document.documentElement.style.overflowY = "scroll";
      let $this = this;
      this.$http
        .post("/api/topic/relevant/createBatchN", {
          topicId: this.topicId,
          topicIds: this.selectList.join()
        })
        .then(response => {
          if (response.code == "OK") {
            $this.$message({
              message: this.$t("global.添加成功"),
              type: "success",
              duration: 1000
            });
            this.getRelevantTopicList();
          } else {
            $this.$message({
              message: this.$t("global.添加失败"),
              type: "error",
              duration: 1000
            });
          }
        });
    },
    checkAll(value) {
      this.checked = value;
      if (this.checked) {
        for (var i = 0; i < this.currentRelevantTopic.length; i++) {
          this.selectRelevantTopic.push(this.currentRelevantTopic[i].id);
        }
      } else {
        this.selectRelevantTopic = [];
      }
    },
    changeRank(item) {
      let index = this.rankList.indexOf(item);
      if (index == -1) {
        this.rankList.push(item);
      }
    },
    /**
     * 执行排序动作
     */
    rankPost() {
      if (this.rankList != null && this.rankList.length > 0) {
        this.$http
          .post("/api/u/topic/relevantTopic/rank", {
            topicId: this.topicId,
            rankList: JSON.stringify(this.rankList)
          })
          .then(response => {
            if (response.data.code == "OK") {
              this.$message.success(this.$t("global.排序成功"));
              this.currentTopicVideo == response.data;
            }
          });
      }
    }
  }
};
</script>

<style scoped>
.el-form {
  float: left;
  width: 994px;
  padding: 22px 13px 0 50px;
  background-color: #fff;
  box-sizing: border-box;
}
.intros {
  padding: 22px 50px 46px;
  overflow: hidden;
  background-color: #fff;
}

.showinfor {
  height: 30px;
  color: #999;
  line-height: 30px;
  font-size: 12px;
  overflow: hidden;
}
.showinfor > span {
  float: left;
}
.showinfor .rightside {
  float: right;
}
input[type="radio"] {
  position: relative;
  top: 2px;
  margin: 0 10px;
}
.showinfor .rightside a {
  display: inline-block;
  height: 30px;
  padding: 0 18px;
  color: #fff;
  border-radius: 2px;
  margin-left: 10px;
  cursor: pointer;
  background-color: rgba(0, 173, 239, 1);
}
.userinforbox {
  overflow: hidden;
  padding-bottom: 20px;
  border-bottom: 1px solid #edecf1;
}
.memberinfor .userinforbox:first-child ~ li {
  padding-top: 20px;
}
.memberinfor .userinforbox:last-child {
  border-bottom: none;
}
.memberinfor {
  margin-top: 42px;
  overflow: hidden;
}
.memberinfor .userinforbox .leftbar {
  float: left;
  width: calc((100% - 80px) / 2);
}
.memberinfor .userinforbox .rightbar {
  margin-left: 80px;
}
.userinforbox .leftbar > img {
  float: left;
  width: 66px;
  height: 66px;
  margin-right: 19px;
}
.mavideo {
  margin-top: 7px;
  height: 20px;
  line-height: 20px;
}

.mavideo input[type="text"] {
  float: right;
  width: 54px;
  text-align: right;
  padding-right: 5px;
  margin-right: 5px;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(151, 151, 151, 1);
  box-sizing: border-box;
}
.mavideo .checkedbox {
  position: relative;
  top: -1px;
  display: inline-block;
  float: right;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: url(/static/home/images/checked.png) no-repeat;
  background-size: 100% 100%;
}
.mavideo .showbox {
  background: url("/static/home/images/ischecked.png") no-repeat;
  background-size: 100% 100%;
}
.mavideo .show {
  display: none !important;
}
.userinforbox .leftbar .usercontent {
  float: left;
  width: 240px;
  color: #999;
  font-size: 12px;
}
.userinforbox .leftbar .usercontent .mavideo b {
  color: #000;
  margin: 0 13px 0 6px;
}

.userinforbox .leftbar .usercontent .name {
  color: #333;
  font-size: 16px;
  height: 44px;
  overflow: hidden;
  line-height: 22px;
  cursor: pointer;
  font-weight: bold;
  text-overflow: ellipsis;
}

.signature {
  color: #999;
  padding-left: 92px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.fixconent .usercontent {
  overflow: hidden;
}

.fixconent .mavideo {
  color: #999;
}
.fixconent .mavideo b {
  color: #000;
  margin: 0 13px 0 6px;
}
.fixconent .checkarea {
  display: block;
  top: 70px;
}
.fixconent .checkarea input {
  display: none;
}
.fixconent .hostactivity li {
  float: left;
  width: 50%;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}
.fixconent .hostactivity li:last-child,
.fixconent .hostactivity li:nth-last-child(2) {
  border-bottom: none;
}
.fixconent .hostactivity li:nth-child(2n + 1) {
  padding-right: 10px;
}
.fixconent .hostactivity li:nth-child(2n) {
  padding-left: 10px;
}
.fixconent .leftbar {
  width: 100%;
}

.fixconent .hostactivity .avatar {
  float: left;
  width: 66px;
  height: 66px;
  margin-right: 16px;
}
.fixconent .hostactivity .name {
  color: #333;
  font-size: 14px;
  height: 40px;
  overflow: hidden;
  line-height: 22px;
  cursor: pointer;
  font-weight: bold;
  text-overflow: ellipsis;
}
.addfixwindow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
  z-index: 999;
  background-color: #000;
}
.fixconent {
  position: fixed;
  width: 607px;
  height: 659px;
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
.fixconent > p {
  height: 50px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  padding: 0 26px;
  line-height: 50px;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}
.headsearch {
  position: relative;
  padding: 0 26px;
  margin: 20px auto 0;
}
.headsearch input {
  width: 100%;
  height: 30px;
  border-radius: 5px;
  padding-left: 10px;
  background: rgba(245, 245, 245, 1);
  box-sizing: border-box;
}
.headsearch img {
  position: absolute;
  top: 5px;
  right: 36px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.fixconent .hostactivity {
  position: relative;
  padding: 0 30px;
  overflow: hidden;
  height: 500px;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}

.fixconent .hostactivity .pages {
  position: absolute;
  margin: 0;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%, 0);
}
.fixconent .underbutton {
  font-size: 12px;
  color: #999;
  height: 30px;
  padding: 0 30px;
  margin-top: 15px;
  line-height: 30px;
}
.fixconent .underbutton span {
  float: left;
}
.fixconent .underbutton span em {
  font-style: normal;
}
.fixconent .underbutton a {
  float: right;
  display: inline-block;
  width: 64px;
  height: 30px;
  cursor: pointer;
  line-height: 30px;
  text-align: center;
  border-radius: 2px;
  box-sizing: border-box;
}
.fixconent .underbutton a.sure {
  color: #fff;
  margin-left: 13px;
  background: rgba(0, 173, 239, 1);
}
.fixconent .underbutton a.cancel {
  color: #999;
  border: 1px solid rgba(224, 224, 224, 1);
}
.fixconent .closepopus {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 17px;
  height: 17px;
  cursor: pointer;
}
.selectbox .showbox {
  background: url("/static/home/images/ischecked.png") no-repeat;
  background-size: 100% 100%;
}
input[type="radio"] {
  position: relative;
  top: 2px;
  margin: 0 10px;
}

.addsed {
  float: right;
  display: inline-block;
  width: 44px;
  height: 18px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  background: rgba(0, 173, 239, 1);
  border-radius: 2px;
}
.intros {
  height: 739px;
  border-top: 1px solid rgba(238, 238, 238, 1);
  box-sizing: border-box;
}
</style>





// WEBPACK FOOTER //
// src/pages/v2/subject/step/Step6.vue